<template>
    <v-container fill-height class="align-start">
        <v-row
            no-gutters
            class="align-self-center"
            align="center"
            justify="center"
        >
            <v-col>
                <v-row
                    align="center"
                    justify="center"
                    no-gutters
                >
                    <v-col class="form">
                        <v-card
                            class="elevation-12"
                            width="89vw"
                            max-width="500px"
                            :loading="loading && 'primary'"
                        >
                            <v-toolbar
                                color="primary"
                                dark
                                flat
                            >
                                <v-toolbar-title>
                                    <span v-if="copyOfRecipient.name">Found <span class="font-weight-bold">{{ copyOfRecipient.name }}</span></span>
                                    <span v-if="isInvitation">Invite a new recipient</span>
                                    <span v-else>Find a new recipient</span>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-form ref="form">
                                    <v-row>
                                        <v-col>
                                            <!-- Email -->
                                            <v-text-field
                                                key="email"
                                                v-model="copyOfRecipient.handle"
                                                v-validate="paymentProviderRules.email_address"
                                                name="email"
                                                label="Email"
                                                color="primary"
                                                outlined
                                                :dense="!!copyOfRecipient.name || isInvitation"
                                                hide-details
                                                :error-messages="errors.first('email')"
                                                @input="validityCheck()"
                                            />
                                        </v-col>
                                        <v-col class="flex-grow-0 pl-0" right>
                                            <v-btn
                                                v-if="!!copyOfRecipient.firstname || isInvitation"
                                                x-large
                                                depressed
                                                outlined
                                                color="red darken-2"
                                                :height="!!copyOfRecipient.name || isInvitation ? 40 : 56"
                                                @click.native="reset"
                                            >
                                                <v-icon>mdi-undo-variant</v-icon>
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                x-large
                                                :dark="emailIsValid"
                                                depressed
                                                color="primary"
                                                height="56"
                                                :disabled="!emailIsValid"
                                                @click.native="getRecipient"
                                            >
                                                Find User
                                            </v-btn>
                                        </v-col>
                                    </v-row>

                                    <v-row v-if="isInvitation">
                                        <v-col>
                                            <!-- Phone -->
                                            <v-text-field
                                                v-model="copyOfRecipient.recipient_info.phone"
                                                v-validate="'international-phone'"
                                                validate-on-blur
                                                :error-messages="errors.first('phone')"
                                                name="phone"
                                                label="Phone number"
                                                color="primary"
                                                outlined
                                                dense
                                                hide-details
                                            />
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                            <v-expand-transition>
                                <v-card-actions
                                    v-if="!!copyOfRecipient.name || isInvitation"
                                    class="pb-6 px-4 align-center"
                                >
                                    <!-- Name -->
                                    <v-expand-transition>
                                        <div v-if="!!copyOfRecipient.name">
                                            <p class="mb-0" color="black">We found <span class="font-weight-bold">{{ copyOfRecipient.name }}</span>!<br/>Click save if they are who you're looking for.</p>
                                        </div>
                                        <div v-else-if="isInvitation">
                                            <p class="mb-0" color="black">
                                                <span class="font-weight-bold">No users found.</span> Try a different email address or invite them to join Kaoshi.</p>
                                        </div>
                                    </v-expand-transition>
                                    <v-spacer />
                                    <v-expand-transition>
                                        <v-btn
                                            v-if="!!copyOfRecipient.name || isInvitation"
                                            class="px-6"
                                            color="primary"
                                            dark
                                            depressed
                                            large
                                            :recipientInfo="recipient"
                                            @click.native="validateThenSave"
                                        >
                                            {{ isInvitation ? 'Invite' : 'Save' }}
                                        </v-btn>
                                    </v-expand-transition>
                                </v-card-actions>
                            </v-expand-transition>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            recipient: {
                type: Object,
                default() {
                    return {
                        user_id: this.$store.state.user.id,
                        handle: null,
                        name: null,
                        recipient_info: {
                            email: null,
                            phone: null,
                            account: null,
                            name: null,
                            branch: null,
                            branch_code: null,
                            address: null,
                            building_number: null,
                            city: null,
                            state: null,
                            country: null,
                            zipcode: null,
                            payment_type: null,
                            payment_provider: null,
                        },
                    };
                },
            },
            returnToPreviousPage: {
                type: Function,
                default() {
                    this.$router.push({ name: 'recipient-list' });
                },
            },
        },
        data,
        computed: getComputed(),
        beforeDestroy,
        methods: getMethods(),
        mounted,
    };

    function data() {
        return {
            loading: false,
            selectedPaymentProvider: null,
            selectedBranch: {},
            selectedBranchCode: null,
            copyOfRecipient: Vue.util.extend({}, this.recipient),
            recipientId: null,
            pageTitle: 'Recipient Details',
            expansionPanel: null,
            emailIsValid: false,
            providers: [],
            // This is hardcoded provider name that used for all poster recipients
            recipientProviderName: 'kaoshi',
            inviteRecipientProviderName: 'kaoshi-invitee',
            isInvitation: false,
        };
    }

    function getMethods() {
        return {
            validateThenSave,
            saveRecipient,
            getRecipient,
            reset,
            validityCheck,
        };


        function validateThenSave() {
            const vm = this;
            vm.$validator.validateAll().then(submitIfValid);
            function submitIfValid() {
                const formIsValid = vm.$refs.form.errors.items.length === 0;
                if (formIsValid) {
                    vm.saveRecipient(vm.copyOfrecipient);
                }
            }
        }

        function saveRecipient() {
            const vm = this;
            vm.loading = true;
            const payload = JSON.parse(JSON.stringify(this.copyOfRecipient));
            const recipientId = payload.id ? payload.id : null;

            const requestPayload = {
                user_id: this.$store.state.user.id,
                recipient_info: {
                    ...payload.recipient_info,
                    payment_provider: vm.paymentProvider, // Pre fill recipient info payment_provider by auto selected provider - kaoshi
                },
                recipient_type: vm.paymentProvider.name, // Pre fill recipient type by provider name - kaoshi
            }

            Vue.backendApi().user(this.$store.state.user.id)
                .recipient(recipientId).storeRecipient(requestPayload)
                .then(success, error);

            function success() {
                vm.loading = false;
                vm.$swal({
                    type: 'success',
                    title: 'Recipient saved!',
                    text: 'Click okay to continue',
                });
                vm.$router.go(-1);
            }

            function error(err) {
                vm.loading = false;
                vm.$swal({
                    type: 'error',
                    title: 'Error saving recipient',
                    text: err,
                });
            }
        }

        function getRecipient() {
            const vm = this;
            return new Promise((resolve, reject) => {
                vm.loading = true;
                Vue.backendApi()
                    .user()
                    .fetchKaoshiUser(vm.copyOfRecipient.handle)
                    .then(success, error);

                function success(response) {
                    vm.loading = false;
                    vm.isInvitation = false;
                    const name = `${response.data.firstname} ${response.data.lastname}`;
                    const email = response.data.handle;
                    const recipient_info = {
                        ...vm.recipient.recipient_info,
                        name,
                        email,
                    }

                    Vue.set(vm, 'copyOfRecipient', response.data);
                    Vue.set(vm.copyOfRecipient, 'name', name);
                    Vue.set(vm.copyOfRecipient, 'user_id', vm.$store.state.user.id);
                    Vue.set(vm.copyOfRecipient, 'recipient_info', recipient_info);
                }

                function error(err) {
                    vm.loading = false;
                    vm.isInvitation = true;

                    const name = '';
                    const email = vm.copyOfRecipient.handle;
                    const recipient_info = {
                        ...vm.recipient.recipient_info,
                        name,
                        email,
                    }

                    Vue.set(vm.copyOfRecipient, 'name', name);
                    Vue.set(vm.copyOfRecipient, 'user_id', vm.$store.state.user.id);
                    Vue.set(vm.copyOfRecipient, 'recipient_info', recipient_info);
                }
            });
        }

        function reset() {
            const vm = this;
            vm.isInvitation = false;
            Vue.set(vm, 'copyOfRecipient', {
                user_id: vm.$store.state.user.id,
                handle: null,
                name: null,
                recipient_info: vm.recipient.recipient_info,
            });
        }

        function validityCheck() {
            const vm = this;
            vm.$validator.validateAll().then(checkForErrors);
            function checkForErrors() {
                const formIsValid = vm.$refs.form.errors.items.length === 0;
                if (formIsValid) {
                    vm.emailIsValid = true;
                } else {
                    vm.emailIsValid = false;
                }
            }

        }
    }

    function getComputed() {
        return {
            paymentProvider,
            paymentProviderRules,
            show: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
        };


        /**
         * Auto select payment provider based on hadrcoded provider name -
         * kaoshi or kaoshi-invitee
         * All poster recipients has the same provider.
         */
        function paymentProvider() {
            const vm = this;
            const providerName = vm.isInvitation ? vm.inviteRecipientProviderName : vm.recipientProviderName ;
            return vm.providers.find(provider => provider.name === providerName);
        };

        function paymentProviderRules() {
            return {
                name: 'required|name|two-words|max:255',
                account_number: 'required|max:255',
                phone_number: '',
                email_address: 'email',
            };
        }
    }

    function mounted() {
        const vm = this;

        Vue.backendApi().deliveryMethods().providers().then(success, error);

        function success(response) {
            Vue.set(vm, 'providers', response.data);
        }

        function error(err) {
            vm.$swal({
                type: 'error',
                title: 'Error retrieving providers',
                text: err,
            });
        }
    }

    function beforeDestroy() {
        const vm = this;
        vm.$store.commit('hideLogoPart', false);
        vm.$store.commit('removeLogoPartClass', 'header-bar-recipient-details');
    }
</script>

<style scoped>
.form {
    max-width: 500px;
}

.v-expansion-panels--tile, .v-expansion-panels--tile>.v-expansion-panel:before {
    border-radius: 0;
}

.v-expansion-panels--flat>.v-expansion-panel:before {
    box-shadow: 0 0 0 0 rgba(0,0,0,.2), 0 0 0 0 rgba(0,0,0,.14), 0 0 0 0 rgba(0,0,0,.12);
}

.v-expansion-panel-content__wrap {
    padding: 0 24px 26px;
}

.v-expansion-panel {
    border: 1px solid;
    border-color: rgba(0, 0, 0, 0.38);
    border-radius: 4px !important;
    transition-duration: .3s;
    transition-property: color,border-width;
    transition-timing-function: cubic-bezier(.25,.8,.25,1);
}

.v-expansion-panel-header {
    padding: 12px 12px;
    color: rgba(0,0,0,.6);
    min-height: 56px;
    font-size: 1rem;
}

.v-expansion-panel--active>.v-expansion-panel-header {
    color: rgba(63, 80, 181, 1);
}

/* .v-expansion-panel--active {
    border: 2px solid;
    border-color: rgba(63, 80, 181, 1);
} */

.v-expansion-panel--active>.v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon {
    color: rgba(63, 80, 181, 1);
}

.theme--light.v-list-item .v-list-item__mask {
    color: unset;
    background: #ffeec7;
    padding: 0 2px;
}

.theme--dark.v-card.v-card--outlined {
    border: 1px solid #FFD54F;
    background-color: transparent;
}
</style>
